// Imports from external sources
// React, i18next, Router, Mantine, Further Stuff
import { 
    ReactNode
} from "react"

// Imports from vseth-canine-ui
import { 
    useAppSelector 
} from "../../hooks/useAppSelector"

import { 
    useAppDispatch 
} from "../../hooks/useAppDispatch"


// Imports from this projects
// Pages, Components, Features, Hooks
import { 
    selectTokens, 
    setAuthState,
    getAuthStateFromToken 
} from "../../features/auth/authSlice"


import { 
    AuthProvider
} from "./AuthProvider"


//Define interfaces/types
type CustomAuthProviderProps = {
    children: ReactNode
}


/**
 * Custom Auth Provider
 */
export const CustomAuthProvider: React.FC<CustomAuthProviderProps> = (props: CustomAuthProviderProps) => {
    const tokens = useAppSelector(selectTokens)
    const dispatch = useAppDispatch()
   
    return (
        <AuthProvider
            setAuthState ={(authState) => {
                dispatch(setAuthState(authState))
            }}
            authState={getAuthStateFromToken(tokens)}    
        >
            {props.children}
        </AuthProvider>
    )
}